import React, {useEffect} from 'react'
import './PdfButton.css'
import Aos from 'aos'
import 'aos/dist/aos.css'

const PdfButton = () => {

  useEffect(() => {
    Aos.init({
        duration: 900
    })
  }, []);


  const linkToBehance = 'https://www.behance.net/gallery/214022047/About-Us';
  return (
    <div className='pdf-button-container card' >
      <a className='pdf-button-link' href={linkToBehance} target='_blank' rel="noreferrer">
        <button className='pdf-button'>
          <p className='pdf-button-header'>Proposal</p>
        </button>
      </a>
    </div>
  )
}

export default PdfButton